import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { HotelContext } from "../context/HotelContext";
import {
  getDefaultHotelPath,
  isV1AppPath,
  parseHotelFeatureNames,
  shouldRedirectV1AppToV2,
} from "../utils/hotelNavigation";

/**
 * Redirige vers la V2 si l'hôtel y a accès (Option Eau, Option Menage ou V2-GreenMiles)
 * mais l'utilisateur est sur une URL de l'ancienne interface.
 */
export const useV2PreferredRedirect = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { hId } = useContext(HotelContext);

  useEffect(() => {
    if (!hId || !auth.isAuthenticated || !auth.user?.access_token) {
      return;
    }

    const path = location.pathname;

    if (!isV1AppPath(path)) {
      return;
    }

    let cancelled = false;

    fetch(`/api/hotels/${hId}/subscriptions/`, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + auth.user.access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((subData) => {
        if (cancelled) return;
        const hotelFeatures = parseHotelFeatureNames(subData);
        if (shouldRedirectV1AppToV2(hotelFeatures)) {
          navigate(getDefaultHotelPath(hotelFeatures), { replace: true });
        }
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [hId, auth.isAuthenticated, auth.user?.access_token, location.pathname, navigate]);
};
